import React, { useEffect, useMemo } from "react";

import { config } from "@app/config";

import { useSearchspringSearchContext } from "@app/providers/searchspring";

import { ResultGrid } from "@app/components/result-grid";
import { ResultFooter } from "@app/components/result-footer";
import { ResultControls } from "@app/components/result-controls";

export type Props = {
  config: typeof config;
  query: string;
};

export function SearchGrid({ config, query }: Props) {
  const { refine } = useSearchspringSearchContext();

  return (
    <div>
      <div className="px-3 py-6 md:p-12">
        <h1>All Results for "{query}"</h1>
      </div>
      <div className="px-4 md:px-12">
        <hr className="border-neutrals-grey-4" />
      </div>
      <ResultControls />
      <ResultGrid />
      <ResultFooter />
    </div>
  );
}
